import { makeRequest, CommonRequestOptions } from '../makeRequest';
import { DocumentType } from '~/monolith-api';

export type RemoveDocumentsFromScheduleOptions = CommonRequestOptions & {
   prsid: number;
   docs: DocumentType[];
};

export function removeDocumentsFromSchedule({
   prsid,
   docs,
   ...common
}: RemoveDocumentsFromScheduleOptions): Promise<void> {
   return makeRequest('delete', `periodic_review/documents`, {
      ...common,
      body: {
         prsid,
         docs,
      },
   });
}
